export enum AppointmentMoveOutcome {
    SUCCESS = 'success',
    PARTIAL = 'partial',
    FAILED = 'failed',
}
